import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environment/vm-admin-ui/environment";
import { Int_update_vm, Int_vm_user } from "../app/models/types";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class MasterService {
  constructor(private http: HttpClient) {
    this.BASE_URL = environment.BASE_API;
    this.USER_URL = environment.USER_API;
  }

  BASE_URL: string = "";
  USER_URL: string = "";

  //#Region Get

  getRoles(): Observable<any> {
    return this.http.get(`${this.USER_URL}/api/mobivisitor/GetMobivistorRoles`);
  }

  getTeamList() {
    return this.http.get(`${this.USER_URL}/api/mobivisitor/GetActiveMobiVistorUsers`);
  }

  //#endregion

  //#region Post

  InsertVmUser(payload: Int_vm_user) {
    return this.http.post(`${this.USER_URL}/api/mobivisitor/CreateUser`, payload);
  }

  //#endregion

  //#region put

  UpdateVMUser(payload: Int_update_vm) {
    return this.http.put(`${this.USER_URL}/api/mobivisitor/UpdateUser`, payload);
  }

  UpdateUserInactive(payload: { UID: number }) {
    return this.http.put(`${this.USER_URL}/api/mobivisitor/InactiveUser`, payload);
  }
}
